import styled from "styled-components";

export const GameNavBarButtonDefaultBox = styled.div`
    padding-top: 6px;
    
    @media ${({theme}) => theme.mediaQuery.portrait } {
        width: 65px;
        height: 48px;
    }

    @media ${({theme}) => theme.mediaQuery.landscape } {
        width: 48px;
        min-height: 48px;
    }
`;